import { normalizeConstructImage } from '../../../../../helpers/construct/page-content.helper';
import { convertToSplashAlignment, convertToSplashButtonStyle } from '../../../../../helpers/home/splash/splash.helper';
import { type ContentComponent, type HomePageSplashContent } from '../../../../../types/construct.types';
import type { HomeSplashCallToAction } from '../../../../../types/home.types';
import { HomeSplash } from '../../../../home-components/home-splash/home-splash.component';

export const HomeSplashHandler: ContentComponent<HomePageSplashContent> = ({
	content: {
		fields: { background, desktop, alignment, mobile, link, backgroundTracking, buttonTracking, buttonText, buttonStyle }
	}
}) => {
	return (
		<HomeSplash
			background={normalizeConstructImage(background)}
			backgroundTracking={backgroundTracking}
			callToAction={
				{
					desktop: normalizeConstructImage(desktop),
					mobile: normalizeConstructImage(mobile),
					alignment: convertToSplashAlignment(alignment),
					style: convertToSplashButtonStyle(buttonStyle),
					text: buttonText ?? '',
					foregroundTracking: buttonTracking ?? null,
					link: {
						name: 'Link',
						url: link.linkUrl,
						tracking: link.trackingCode ?? ''
					}
				} satisfies HomeSplashCallToAction
			}
		/>
	);
};
